module.exports = __webpack_public_path__ + "static/media/ShortAppPromo.e1fbfbc2.mp4";